import IntroductionBanner from 'components/IntroductionBanner/IntroductionBanner'
import styles from './AllCategoriesList.module.css'
import { CategoryItem } from 'frontend/types'
import SpaLink from 'components/SpaLink/SpaLink'
import Syntolkat from 'assets/icons/audio-described.svg'
import classnames from 'classnames'

interface Props {
  allCategories: CategoryItem[]
  minorityLanguageCategories: CategoryItem[]
  schoolCategories: CategoryItem[]
  childCategories: CategoryItem[]
}

const AllCategoriesList = ({
  allCategories,
  minorityLanguageCategories,
  schoolCategories,
  childCategories,
}: Props) => {
  return (
    <>
      <IntroductionBanner title="Alla kategorier" />
      <div className={styles.audioDescribedWrapper}>
        <SpaLink
          href={`/bladdra/syntolkat`}
          className={classnames(styles.link, styles.audioDescribed)}
        >
          <Syntolkat className={styles.audioDescribedIcon} />
          Syntolkat
        </SpaLink>
      </div>
      <div className={styles.wrapper}>
        <ul className={styles.categoryList}>
          {allCategories.map(category => (
            <li key={category.slug} className={styles.categoryListItem}>
              <SpaLink
                href={`/bladdra/${category.slug}`}
                className={styles.link}
              >
                {category.name}
              </SpaLink>
            </li>
          ))}
        </ul>
        {schoolCategories.length > 0 && (
          <>
            <h2 className={styles.levelTwoHeading}>Skola</h2>
            <ul className={styles.categoryList}>
              {schoolCategories.map(category => (
                <li key={category.slug} className={styles.categoryListItem}>
                  <SpaLink
                    href={`/bladdra/${category.slug}`}
                    className={styles.link}
                  >
                    {category.name}
                  </SpaLink>
                </li>
              ))}
            </ul>
          </>
        )}
        {childCategories.length > 0 && (
          <>
            <h2 className={styles.levelTwoHeading}>Barn</h2>
            <ul className={styles.categoryList}>
              {childCategories.map(category => (
                <li key={category.slug} className={styles.categoryListItem}>
                  <SpaLink
                    href={`/bladdra/${category.slug}`}
                    className={styles.link}
                  >
                    {category.name}
                  </SpaLink>
                </li>
              ))}
            </ul>
          </>
        )}
        {minorityLanguageCategories.length > 0 && (
          <>
            <h2 className={styles.levelTwoHeading}>Nationella minoriteter</h2>
            <ul className={styles.categoryList}>
              {minorityLanguageCategories.map(category => (
                <li key={category.slug} className={styles.categoryListItem}>
                  <SpaLink
                    href={`/bladdra/${category.slug}`}
                    className={styles.link}
                  >
                    {category.name}
                  </SpaLink>
                </li>
              ))}
            </ul>
          </>
        )}
      </div>
    </>
  )
}

export default AllCategoriesList
